function makeAppRoute({ path, appName }) {
    const getRoute = _path => ({
        type: 'route',
        path: _path,
        routes: [{ type: 'application', name: appName }],
    });

    if (Array.isArray(path)) {
        return path.map(t => getRoute(t));
    }

    return getRoute(path);
}

const navMfe = {
    type: 'nav',
    attrs: [
        {
            name: 'class',
            value: 'topnav',
        },
    ],
    routes: [{ type: 'application', name: '@cloud/nav' }],
};

const mainMfe = {
    type: 'route',
    default: true,
    routes: [{ type: 'application', name: '@cloud/main' }],
};

export function makeRoutes({ isMember }) {
    if (isMember) {
        return [
            navMfe,
            {
                type: 'main',
                routes: [
                    ...makeAppRoute({
                        path: ['devices', 'instructions'],
                        appName: '@cloud/udm',
                    }),
                    makeAppRoute({
                        path: 'account',
                        appName: '@sso/account',
                    }),
                    mainMfe,
                ],
            },
        ];
    }

    return [
        { type: 'application', name: '@openvpn/billing-banner-mf' },
        { type: 'application', name: '@openvpn/billing-purchase-modal-mf' },
        navMfe,
        {
            type: 'main',
            routes: [
                makeAppRoute({
                    path: 'publishing',
                    appName: '@cloud/publishing',
                }),
                makeAppRoute({
                    path: 'status',
                    appName: '@cloud/cv',
                }),
                makeAppRoute({
                    path: 'cybershield',
                    appName: '@cloud/shield',
                }),
                makeAppRoute({
                    path: 'log-streaming',
                    appName: '@cloud/log-streaming',
                }),
                makeAppRoute({
                    path: 'access-visibility',
                    appName: '@cloud/av',
                }),
                makeAppRoute({
                    path: 'audit-log',
                    appName: '@cloud/audit-log',
                }),
                makeAppRoute({
                    path: 'dns-log',
                    appName: '@cloud/dr',
                }),
                ...makeAppRoute({
                    path: ['access-control', 'access-internet'],
                    appName: '@cloud/access',
                }),
                ...makeAppRoute({
                    path: [
                        'devices',
                        'users',
                        'groups',
                        'instructions',
                        'get-connected',
                        'location-context',
                        'device-posture',
                    ],
                    appName: '@cloud/udm',
                }),
                ...makeAppRoute({
                    path: ['networks', 'hosts', 'deploy-connector', 'configure-connector'],
                    appName: '@cloud/network',
                }),
                makeAppRoute({
                    path: 'billing',
                    appName: '@openvpn/cloud-billing-mf',
                }),
                makeAppRoute({
                    path: 'api',
                    appName: '@cloud/api',
                }),
                ...makeAppRoute({
                    path: ['account', 'saml-configure'],
                    appName: '@sso/account',
                }),
                ...makeAppRoute({
                    path: ['wizard', 'select-plan'],
                    appName: '@cloud/wizard',
                }),
                mainMfe,
            ],
        },
    ];
}
